import { NEXT_PUBLIC_IMAGE_CDN_URL } from './constants';
import { getCDNURL } from './get-cdn-url';

export function getCountryFlagUrl(
  twoDigitCountryAbbreviation: string | undefined,
  width: number = 20,
  height: number = 20
): string {
  if (!twoDigitCountryAbbreviation) return '';

  return getCDNURL(
    `${NEXT_PUBLIC_IMAGE_CDN_URL}/circle-flags/${twoDigitCountryAbbreviation.toLowerCase()}.svg`,
    width,
    height
  );
}
